const baseModalDialogContentSx = {
  '&.MuiDialogContent-root': {
    padding: 0
  }
};

const baseModalDialogSx = {
  '& .MuiDialog-paper': {
    padding: theme => theme.constants.padding.modal,
    margin: '16px'
  }
};

export { baseModalDialogContentSx, baseModalDialogSx };
